export enum DocumentType {
    Email = 1,
    Fax = 2,
    File = 3,
    Tchat = 4,
    Comment = 5,
    MergedComment = 6,
    Sms = 7,
    Favorite = 100 /* Type virtuel utilisé pour afficher les fichiers favoris */,
}
